export const groupEditTheme = {
  enableAll: {
    bg: 'palette.surface.4',
    title: 'palette.neutral.90',
  },
};
